// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","371":"component---src-pages-tos-js","745":"component---src-pages-privacy-js"}[chunkId] + "-" + {"125":"e30164e5ebead216af46","293":"95a00a71af8472b561f3","371":"ff19c4d800d97edf46aa","745":"f4ceb5419a55904bad58"}[chunkId] + ".js";
};